import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const BillingAdjustmentDomesticStepConfig: StepConfig = {
    type: FormType.BILLING_ADJUSTMENT_DOMESTIC
};
